import { useState, useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { unitsAction, modalAction } from '../../../redux/actions';
import { informationToast, errorToast, } from '../../../utils/Toast/index';
import { findPicturePassportByDate, updateNoteOnPicturePassportByDate, loadPicturePassportByDate, 
          deletePicturePassportByDate, copyPicturePassportByDate } from '../../../api/other/report';
import { findGuestByRequest } from '../../../api/guest';
import ModalSupportOption from "../../Unit/Modal/modalSupportOption";
import ModalNotify from "../../../features/ModalNotify";

export default function PassportPhotoManager() {
    const dispatch = useDispatch();

    const today = new Date().toISOString().slice(0, 10); // yyyy-mm-dd
    const thisMonth = today.slice(0, 7); // yyyy-mm
    const [file, setFile] = useState(null);

    const [photos, setPhotos] = useState([]);
    const [images, setImages] = useState([]);

    const [textSearnch, setTextSearnch] = useState("");
    const [textSearnchDatabase, setTextSearnchDatabase] = useState("")

    const [openSearchScreen, setOpenSearchScreen] = useState(false);

    const [note, setNote] = useState("");
    const [selectedDate, setSelectedDate] = useState(today);
    const [selectedMonth, setSelectedMonth] = useState(thisMonth);
    const auth = useSelector(state => state.auth);
    const { branchID } = auth.user;
    const token = useSelector(state => state.token);

  // Load saved data
  useEffect(() => {
    const saved = localStorage.getItem("passport_photos");
    if (saved) setPhotos(JSON.parse(saved));
  }, []);

    // Load ảnh mỗi khi chọn ngày mới
  useEffect(() => {
    if (!branchID || !selectedDate) return;

    const loadDataBranch = async () => {
      try {
        dispatch(unitsAction.showLoading(true));
        const dataResult = await loadPicturePassportByDate(branchID, selectedDate, token);
        if (dataResult.data) {
          if(dataResult.data.status === 1) setImages(dataResult.data.images);
          else errorToast("Error when load data picture");
        } else errorToast("Error when load data picture");
        dispatch(unitsAction.hiddenLoading());
      } catch (error) {
        errorToast("Error when load data picture")
      }
    }

    loadDataBranch();

    // axios
    //   .get(`http://localhost:3000/report/8/load_picture_passport_by_date/`+selectedDate, {
    //     params: { branchID, date: selectedDate },
    //   })
    //   .then((res) => {
    //     if (res.data.success) setImages(res.data.images);
    //   })
    //   .catch((err) => console.error("Error fetching images:", err));
  }, [branchID, selectedDate, dispatch, token]);

  // const days = Array.from({ length: 7 }).map((_, i) => {
  //   const d = new Date();
  //   d.setDate(d.getDate() - i);
  //   const dateStr = d.toISOString().slice(0, 10).replace(/-/g, "");
  //   return dateStr;
  // });

  // Save to localStorage
  useEffect(() => {
    localStorage.setItem("passport_photos", JSON.stringify(photos));
  }, [photos]);

  const handleFileChange = (e) => {
      handleImageChange(e)    
  };

  const handleEnter = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      onFindPicturePassPort();
    }
  };

 const handleEnter2 = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      onFindPicturePassPortOnDatabase();
    }
  };

  const handleImageChange = (event) => {
      const file = event.target.files[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = (e) => {
          const img = new Image();
          img.onload = () => {
              const canvas = document.createElement("canvas");    
              const MAX_WIDTH = 1500; // Set maximum width for the resized image
              const scaleFactor = MAX_WIDTH / img.width;
              canvas.width = MAX_WIDTH;
              canvas.height = img.height * scaleFactor;
              const ctx = canvas.getContext("2d");
              ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
            //  const resizedDataURL = canvas.toDataURL("image/png");
              let resizedDataURL 
              canvas.toBlob((blob) => {
                  resizedDataURL = new File([blob], "fileName.jpg", { type: "image/jpeg" })
                  setFile(resizedDataURL);
              }, 'image/jpeg');
          };
          img.src = e.target.result;
      };
      reader.readAsDataURL(file);
  };

  const handleUploadPassport = async () => {
      const formData = new FormData();
      formData.append('image', file);
      formData.append("branchID", branchID);
      formData.append("note", note);
      formData.append("selectedDate", selectedDate);

      const now = new Date().getTime();
      //formData.append('image_data', file);
      // image_data
      try {

        
        const response = await fetch(`/passport-by-date/?branchID=${branchID}`, { //+dataState._id
          method: 'POST',
          body: formData,
          date: now,
          branchID: branchID,
        });
  
        if (response.ok) {
          const data = await response.json();
          console.log('URL ảnh đã tải lên:', data);
          
          const newIMG = [...images];
          newIMG.push(data);
          setImages(newIMG);
          // const responseUpPassport = await uploadPassPort(dataState._id, { link:data.imageUrl }, token);

          // //console.log("responseUpPassport", responseUpPassport);

          // if(responseUpPassport) {
          //     if(responseUpPassport.data.status === 1) informationToast(responseUpPassport.data.msg);
          //     else errorToast(responseUpPassport.data.msg);
          // }
          // // update to server
          // setDataState({
          //     ...dataState,
          //     passport: data.imageUrl
          // })
        } else {
          errorToast("Error when upload Passport, Please check the photo size < 1Mb")
          //console.error('Lỗi tải lên ảnh.');
        }
      } catch (error) {
        console.error('Lỗi kết nối máy chủ:', error);
      }
  };

  function onComfirmDeletePicture(id) {

      const onDelete = async () =>  {
          try {
              const result = await deletePicturePassportByDate(id, token);
              if(result) {
                  if(result.data.status === 1) {
                      informationToast("" + result.data.msg);
                     // window.location.reload(false);

                      const newList = images.filter(item => item._id !== id);
                      setImages(newList);
                      closeModal();
                  } else return errorToast("Error deleting picture")
              } else return errorToast("Error deleting picture")
          } catch (error) {
              return errorToast("Error deleting picture")
          }
      }

      dispatch(modalAction.modalChange({
          type: "centered",
          title: "Confirm Delete Picture",
          size: 'xs',
          content: < ModalSupportOption
              type={89}
              btnName1 = {"DELETE"}
              btnName2 = {"CLOSE"}
              // title = "Confirm Delete Picture"
              // color = "red"
              itemOption={{
                color: "red",
                title: "Confirm Delete Picture",
                btnName1: "DELETE",
                btnName2: undefined,
                btnName3:"CLOSE"
              }}
              featureButton1={onDelete}
              featureButton3={closeModal}
          />
      }));
      openModal();
  }
  // Filter photos by selected month
  const filteredPhotos = photos.filter((p) =>
    p.date.startsWith(selectedMonth)
  );

  // Days with photos
  const daysWithPhotos = Array.from(
    new Set(filteredPhotos.map((p) => p.date))
  ).sort((a, b) => b.localeCompare(a));

  // Photos of selected day

  // Days of month
  const daysInMonth = (() => {
    const [year, month] = selectedMonth.split("-").map(Number);
    const lastDay = new Date(year, month, 0).getDate();
    return Array.from({ length: lastDay }, (_, i) => i + 1);
  })();

  // Khi thay đổi note
const handleNoteChange = (id, newNote) => {
  setImages((prev) =>
    prev.map((img) => (img._id === id ? { ...img, note: newNote } : img))
  );
};

function onCopyPassPort(dataPassport) {

  const copyPassport = async (date, note) => {
    // console.log("date", date);
    // console.log("note", note)
      try {
          dispatch(unitsAction.showLoading(true));
          const dataResult = await copyPicturePassportByDate({
            branchId: branchID,//branchID,
            filename: dataPassport.filename,
            note: note,
            date: date,
            filepath: dataPassport.filepath,
          }, token)

          if(dataResult.data) {
            if(dataResult.data.status === 1) {
              informationToast(dataResult.data.msg);
              closeModal();
            }
            else errorToast("Error when copy passport");
          } else  errorToast("Error when copy passport");
          dispatch(unitsAction.hiddenLoading());
      } catch (error) {
        errorToast("Error when copy passport")
      }
  };

  dispatch(modalAction.modalChange({
    type: "centered",
    title: "Confirm Copy Picture",
    size: 'xs',
    content: < ModalSupportOption
        type={19}
        btnName1 = {"COPY"}
        btnName2 = {"CLOSE"}
        // title = "Confirm Delete Picture"
        // color = "red"
        itemOption={{
          link: dataPassport.filepath,
          color: "red",
          title: "Confirm Copy Picture",
          note: dataPassport.note,
          date: today,
          btnName1: "COPY",
          btnName2: undefined,
          btnName3:"CLOSE",
        }}
        featureButton1={copyPassport}
        featureButton2={closeModal}
    />
  }));

  openModal();
}
// Khi rời input (blur) => lưu lên server
const saveNote = async (id) => {
  const img = images.find((i) => i._id === id);
  if (!img) return;

  try {
    dispatch(unitsAction.showLoading(true));
    const dataResult = await updateNoteOnPicturePassportByDate(id, { note: img.note }, token);
    if(dataResult.data) {
      if(dataResult.data.status === 1) informationToast(dataResult.data.msg);
      else errorToast("Error when update note");
    } else errorToast("Error when update note");
    dispatch(unitsAction.hiddenLoading());
  } catch (err) {
    console.error("Save note failed:", err);
    errorToast("Error update note")
  }
};

const onFindPicturePassPort = async () =>{
  setImages([]);

  if(openSearchScreen === true) {
    setTextSearnch("");
    setOpenSearchScreen(!openSearchScreen);
    setSelectedDate(today);

  } else {
        setOpenSearchScreen(!openSearchScreen)
     try {
        dispatch(unitsAction.showLoading(true));
        const dataOnBoday = {
          value: textSearnch,
          type:"name"
        }
        const dataResult = await findPicturePassportByDate(dataOnBoday, token);
        // console.log("dataResult", dataResult)
        setImages(dataResult.data.data);
        dispatch(unitsAction.hiddenLoading());
    } catch (error) {
        errorToast("Error when find picture")
    }
  }
}

const onFindPicturePassPortOnDatabase = async () => {
   setImages([]);
     if(openSearchScreen === true) {
    setTextSearnch("");
    setOpenSearchScreen(!openSearchScreen);
    setSelectedDate(today);

    } else {
        setOpenSearchScreen(!openSearchScreen)
     try {
        dispatch(unitsAction.showLoading(true));

        const dataResult = await findGuestByRequest("passportPicture", textSearnchDatabase, token);

         console.log("dataResult", dataResult)
        setImages(dataResult.data);
        dispatch(unitsAction.hiddenLoading());
    } catch (error) {
        errorToast("Error when find picture")
    }
  }
}

function closeModal() { dispatch(modalAction.modalReset()); }
function openModal() { dispatch(modalAction.modalIsOk()); }

return (
    <>
        <ModalNotify closeModal={closeModal} />
        <div>
            <h1 style={{margin:"auto", marginTop:"12px"}}>Update Passport by Date
            <div className="no-print btn btn-primary ml-4 mb-2"
          onClick={()=> {window.open("https://www.youtube.com/embed/e0Lw23boVac")}}>Video tutorial</div>
          </h1>
        </div>

      <div>
        <input value = {textSearnch} onChange={e => setTextSearnch(e.target.value)} onKeyDown={handleEnter}></input>
        <button className={openSearchScreen ? "btn btn-danger" :"btn btn-primary"} 
                disabled={textSearnch.length >= 3 ? false : true}
                
                onClick={() => onFindPicturePassPort()}>
          {openSearchScreen ? "Close Find" : "Find Picture"}
        </button>
      </div>
 
      <div>----</div>
      <div style={{ display: "flex", height: "100vh", fontFamily: "sans-serif",}}>
        {/* LEFT COLUMN - Day selection */}
        {!openSearchScreen && <div
          style={{
            flex: "1",
            borderRight: "1px solid #ccc",
            padding: 10,
            overflowY: "auto",
          }}
        >
          <h3 style={{ marginBottom: 10 }}>🗓️ Select Month:</h3>
          <input
            type="month"
            value={selectedMonth}
            onChange={(e) => {
              setSelectedMonth(e.target.value);
              setSelectedDate("");
            }}
            style={{ width: "100%", marginBottom: 10 }}
          />

          <h4 style={{ marginBottom: 5 }}>Days:</h4>
          <div style={{ maxHeight: "80vh", overflowY: "auto" }}>
            {daysInMonth.map((day) => {
              const dateStr = `${selectedMonth}-${String(day).padStart(2, "0")}`;
              const hasPhotos = daysWithPhotos.includes(dateStr);
              return (
                <div
                  key={day}
                  onClick={() => setSelectedDate(dateStr)}
                  style={{
                    padding: "6px 10px",
                    marginBottom: 4,
                    borderRadius: 4,
                    cursor: "pointer",
                    backgroundColor:
                      selectedDate === dateStr
                        ? "#007bff"
                        : hasPhotos
                        ? "#e6f0ff"
                        : "#f8f8f8",
                    color:
                      selectedDate === dateStr
                        ? "white"
                        : hasPhotos
                        ? "#007bff"
                        : "#333",
                    fontWeight: hasPhotos ? "bold" : "normal",
                  }}
                >
                  Day {day}
                </div>
              );
            })}
          </div>
        </div>}

      {/* CENTER COLUMN - Hiển thị ảnh ngang */}
        <div
          style={{
            flex: "6",
            borderRight: "1px solid #ccc",
            padding: 20,
            overflowX: "auto",  // 🔹 Cho phép cuộn ngang
            whiteSpace: "nowrap", // 🔹 Xếp ngang không xuống dòng
          }}
        >
          <h3 style={{ marginBottom: 10 }}>
            📷 Photos on: {selectedDate ? selectedDate : "No date selected"}
          </h3>

          {images.length === 0 ? (
            <p className="text-gray-500 text-center">No images for this date</p>
          ) : (
            <div className="container">
              <div className="row">
                {images.map((img) => (
                  <div
                    className="col-md-4"
                    key={img._id}
                    style={{
                      width: "220px",
                      height: "fit-content",
                      border: "1px solid #ccc",
                      borderRadius: "8px",
                      padding: "8px",
                      backgroundColor: "#fff",
                      textAlign: "center",
                    }}
                  >
                    <img
                      src={`https://database.azumayareport.com/${img.filepath}?v=${new Date().getTime()}`}
                      alt={img.note || "Passport photo"}
                      style={{
                        width: "340px",
                        height: "400px",
                        // objectFit: "cover",
                        borderRadius: "6px",
                      }}
                    />
                    <div>
                      <input
                        type="text"
                        value={img.note}
                        onChange={(e) => handleNoteChange(img._id, e.target.value)}
                        onBlur={() => saveNote(img._id)}
                        placeholder="Enter note..."
                        style={{
                          fontSize: "13px",
                          marginTop: "6px",
                          color: "#444",
                          overflow: "hidden",
                          width:"200px",
                          // textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      />
                      <i className="ml-1 fa-solid fa-copy" style={{color:"green", fontSize:"1.4rem", cursor:"pointer"}}
                          onClick={()=>onCopyPassPort(img)}></i>
                      {!openSearchScreen && <i className="ml-1 fa-solid fa-trash" style={{color:"red", fontSize:"1.4rem", cursor:"pointer"}}
                          onClick={()=>onComfirmDeletePicture(img._id)}></i>}

                    </div>
                    {openSearchScreen && <p
                      style={{
                        fontSize: "13px",
                        color: "#444",
                        marginLeft: "30px",
                        textAlign: "left"
                        // overflow: "hidden",
                        // textOverflow: "ellipsis",
                        // whiteSpace: "nowrap",
                      }}
                    >
                      Date: {img.date}
                    </p> }
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* CENTER COLUMN - Photos */}
        {/* <div
          style={{
            flex: "3",
            borderRight: "1px solid #ccc",
            padding: 20,
            overflowY: "auto",
          }}
        >
          <h3 style={{ marginBottom: 10 }}>
            📷 Photos on:{" "}
            {selectedDate ? selectedDate : "No date selected"}
          </h3>

          {!selectedDate ? (
            <p style={{ color: "#777" }}>Please select a date to view photos.</p>
          ) : photosOfDay.length === 0 ? (
            <p style={{ color: "#777" }}>No photos for this day.</p>
          ) : (
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
                gap: 12,
              }}
            >
              {photosOfDay.map((photo) => (
                <div
                  key={photo.id}
                  style={{
                    border: "1px solid #ddd",
                    borderRadius: 8,
                    overflow: "hidden",
                    background: "#fff",
                    position: "relative",
                  }}
                >
                  <img
                    src={photo.image}
                    alt="passport"
                    style={{
                      width: "100%",
                      height: 160,
                      objectFit: "cover",
                      background: "#f3f3f3",
                    }}
                  />
                  <div style={{ padding: 8 }}>
                    <p
                      style={{
                        fontSize: 13,
                        color: "#555",
                        minHeight: 40,
                        marginBottom: 6,
                      }}
                    >
                      📝 {photo.note || "No note"}
                    </p>
                    <button
                      onClick={() => handleDelete(photo.id)}
                      style={{
                        background: "red",
                        color: "white",
                        border: "none",
                        borderRadius: 4,
                        padding: "4px 8px",
                        cursor: "pointer",
                      }}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div> */}

        {/* RIGHT COLUMN - Add photo */}
        {!openSearchScreen && <div style={{ flex: "1", padding: 20 }}>
          <h3>➕ Add New Photo</h3>
          {!selectedDate ? (
            <p style={{ color: "#777" }}>Select a date first before adding a photo.</p>
          ) : (
            <>
              <div style={{ marginBottom: 10 }}>
                <label>Choose image:</label>
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleFileChange}
                  style={{ display: "block", marginTop: 5 }}
                />
              </div>

              <div style={{ marginBottom: 10 }}>
                <label>Note:</label>
                <textarea
                  placeholder="Enter note for this photo..."
                  value={note}
                  onChange={(e) => setNote(e.target.value)}
                  rows={4}
                  style={{ width: "100%", marginTop: 5 }}
                />
              </div>

              <button
                onClick={handleUploadPassport}
                disabled={!file || !selectedDate}
                style={{
                  backgroundColor:
                    file && selectedDate ? "#007bff" : "#ccc",
                  color: "white",
                  border: "none",
                  padding: "8px 16px",
                  borderRadius: 4,
                  cursor:
                    file && selectedDate ? "pointer" : "not-allowed",
                }}
              >
                Save Photo
              </button>
              <div className="mt-3" style={{fontSize:'1.2rem'}}>Or find on New Database :</div>
              <div className="mb-2  mb-2" style={{fontSize:'1rem'}}>* Name / membership ID:</div>
              <input
                type="text"
                value={textSearnchDatabase}
                onChange={e => setTextSearnchDatabase(e.target.value)}
                onKeyDown={handleEnter2}
                placeholder="Search..."
              ></input>
              <button className={openSearchScreen ? "btn btn-danger mt-2" :"btn btn-success mt-2"} 
                  onClick={() => onFindPicturePassPortOnDatabase()}
                  disabled={textSearnchDatabase.length >= 3 ? false : true}>Find Database</button>
            </>
          )}
        </div>}
      </div>
    </>
  );
}
